import { Component, inject, OnInit } from '@angular/core';
import { PagePayErrorPresenter } from '../preseneters/page_error.presenter';
import { IEvent, PaymentBusEventsService } from '../../services/payment.busevents.service';
import { ActivatedRoute } from '@angular/router';
import { LoaderSubjectService } from 'app/shared/ui-commons/ui-spinner/util-commons/service/loader-subject.service';
import { debounceTime, tap } from 'rxjs';
import { FacadeLinkPaymentService } from '../../services/payment.service';
import { PageCardHolderComponent } from "../page-card-holder/page-card-holder.component";
import { PageInfoBillingComponent } from "../page-info-billing/page-info-billing.component";
import { IzipayPageComponent } from "../izipay-page/izipay-page.component";
import { PageTransferResumeComponent } from "../page-transfer-resume/page-transfer-resume.component";
import { PageErrorGlobalComponent } from "../page-error-global/page-error-global.component";
import { NewRelicService } from '../../services/newRelic.service';

@Component({
  selector: 'cv-payment-flow',
  templateUrl: './payment-flow.component.html',
  imports: [
    PageCardHolderComponent,
    PageInfoBillingComponent,
    IzipayPageComponent,
    PageTransferResumeComponent,
    PageErrorGlobalComponent
  ]
})
export class PaymentFlowComponent implements OnInit {

  public showCard = {
    showCaradIziPay: false,
    showCaradIziResume: false,
    showCardIziError: false,
    showCardIziCardOwner: false,
    showCardInfoBilling: false,
  }

  public ppep = new PagePayErrorPresenter();

  private newRelicService = inject(NewRelicService);
  private readonly pbes = inject(PaymentBusEventsService);
  private readonly route = inject(ActivatedRoute);
  private readonly loader = inject(LoaderSubjectService);
  private readonly flps = inject(FacadeLinkPaymentService);

  ngOnInit(): void {
    this.init();
  }

  private init() {
    this.loader.showLoader();
    const token = this.route.snapshot.paramMap.get('token');
    this.pbes.sendEvent({
      code: 'GET_INFO_IZIPAY',
      description: '',
      ws_token: token
    } as IEvent);

    this.pbes.eventBus$
      .pipe(
        debounceTime(500),
        tap((event: IEvent) => {
          switch (event.code) {
            case 'GET_INFO_IZIPAY':
              this.newRelicService.addPageAction('GET_INFO_IZIPAY', {
                component: 'PaymentFlowComponent',
                action: 'GET_INFO_IZIPAY',
                detail: 'Obtiene la información de Izipay con el token: ' + token,
                timestamp: new Date().toISOString()
              });
              this.setDataAndShowScreen(event);
              this.flps.pay();
              break;
            case 'STORE_INFO_IZIPAY':
              this.newRelicService.addPageAction('STORE_INFO_IZIPAY', {
                component: 'PaymentFlowComponent',
                action: 'STORE_INFO_IZIPAY',
                detail: 'Información de la pasarela almacenada',
                timestamp: new Date().toISOString()
              });
              this.loader.closeLoader();
              this.setDataAndShowScreen({
                code: 'SHOW-IS-CARD-OWNER',
                description: 'Datos de la pasarela almacenados'
              } as IEvent);
              break;
            case 'OPEN_GATEWAY_IZIPAY':
              this.newRelicService.addPageAction('OPEN_GATEWAY_IZIPAY', {
                component: 'PaymentFlowComponent',
                action: 'OPEN_GATEWAY_IZIPAY',
                detail: 'Abre el SDK de Izipay',
                timestamp: new Date().toISOString()
              });
              this.setDataAndShowScreen(event);
              break;
            case 'OPEN-INFO-BILLING':
              this.newRelicService.addPageAction('OPEN-INFO-BILLING', {
                component: 'PaymentFlowComponent',
                action: 'OPEN-INFO-BILLING',
                detail: 'Muestra la pantalla de NO titular de la tarjeta de debito',
                timestamp: new Date().toISOString()
              });
              this.setDataAndShowScreen(event);
              break;
            case 'STORE_INFO_TRASNFER':
              this.newRelicService.addPageAction('STORE_INFO_TRASNFER', {
                component: 'PaymentFlowComponent',
                action: 'STORE_INFO_TRASNFER',
                detail: 'Información de la transferencia almacenada',
                timestamp: new Date().toISOString()
              });
              this.setDataAndShowScreen(event);
              break;
            case 'PAYMENT-ERROR':
              this.newRelicService.addPageAction('PAYMENT-ERROR', {
                component: 'PaymentFlowComponent',
                action: 'PAYMENT-ERROR',
                detail: 'Ocurrió un error en el proceso de pago',
                timestamp: new Date().toISOString()
              });
              this.setDataAndShowScreen(event);
              break;
            default:
              break;
          }
        })
      )
      .subscribe();
  }

  setDataAndShowScreen(event: IEvent) {
    const { code } = event;
    console.log(code)

    if (code === undefined) return;
    if (code === 'STORE_INFO_IZIPAY') return;

    this.showCard.showCaradIziPay = false;
    this.showCard.showCaradIziResume = false;
    this.showCard.showCardIziError = false;
    this.showCard.showCardInfoBilling = false
    this.showCard.showCardIziCardOwner = false;

    if (code) {
      if (code === 'STORE_INFO_TRASNFER') {
        this.showCard.showCaradIziResume = true;
        this.loader.closeLoader();
      }

      if (code === 'OPEN_GATEWAY_IZIPAY') {
        this.loader.showLoader();
        this.showCard.showCaradIziPay = true;
      }

      if (code === 'SHOW-IS-CARD-OWNER') {
        this.showCard.showCardIziCardOwner = true;
      }

      if (code === 'OPEN-INFO-BILLING') {
        this.showCard.showCardInfoBilling = true;
      }

      if (code === 'PAYMENT-ERROR') {
        this.ppep.form_error.detail1 = '';
        this.ppep.form_error.detail2 = '';
        this.showCard.showCardIziError = true;
      }
    }
  }
}